import { isPublicPath } from "@/utilities/navigation";

export function redirectToLogin(): void {
  if (isPublicPath(window.location.pathname)) {
    return;
  }
  const destination =
    window.location.pathname + window.location.search + window.location.hash;
  window.location.replace(
    `/login?redirectTo=${encodeURIComponent(destination)}`,
  );
}
